module.exports = __webpack_public_path__ + "resources/icon_28_right_arrow_blue.1adbaf2781921613.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_right_arrow_blue.png
// module id = 429
// module chunks = 0 1 2 3 4